<template>
  <div id="vehicle_create" class="fleet-form-main">
      <div :class="`loader${loaderClass}`" v-show="loading"></div>
      <div id="page-content-wrapper" class="admin-content-area">
          <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="vehicleHeader">Update User Log Entry</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="Back" >
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content user-logentry-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal form-custom-select basic-form-container" id="TransportingRequestForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label require" for="requested_by">Name:</label>
                                        <input type="text" class="form-control" v-model="name" id="requested_by"
                                        placeholder="Enter Inderect Labor Code" name="requested_by" disabled>
                                        <div class="field-error">{{name_err_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="requested_by">Date:</label>
                                        <input type="text" class="form-control" v-model="current_date" id="requested_by"
                                        placeholder="Date" name="requested_by" disabled>
                                        <div class="field-error">{{current_date_err_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="requested_by">Total Maintenance:</label>
                                        <input type="text" class="form-control" v-model="total_maintenance" id="requested_by"
                                        placeholder="Enter Total Maintenance" name="requested_by" disabled>
                                        <div class="field-error">{{total_maintenance_err_msg}}</div>
                                    </div>

                                    <div class="col form-group">
                                        <label class="control-label require" for="requested_by">Total Break:</label>
                                        <input type="text" class="form-control" v-model="total_break" id="requested_by" placeholder="Enter Total Break" name="requested_by" disabled>
                                        <div class="field-error">{{total_break_err_msg}}</div>
                                    </div>

                                    <div class="col form-group">
                                        <label class="control-label require" for="requested_by">Total Time:</label>
                                        <input type="text" class="form-control" v-model="total_time" id="requested_by"
                                        placeholder="Enter Total Time" name="requested_by" disabled>
                                        <div class="field-error">{{total_time_err_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="requested_by">Status:</label>
                                        <input type="text" class="form-control" v-model="status" id="requested_by"
                                        placeholder="Enter Status" name="requested_by" disabled>
                                        <div class="field-error">{{status_err_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="requested_by">Updated Total:</label>
                                        <input class="form-control" v-model="updated_total" id="requested_by" placeholder="Enter Updated Total" name="requested_by"
                                        @keypress="isAmountCheck($event)">
                                        <div class="field-error">{{updated_total_err_msg}}</div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="createBtn" class="btn btn-primary" v-on:click.prevent="UpdateLog" >
                                    <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" id="cancelBtn" class="btn btn-tertiary" v-on:click.prevent="Back" >
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>  
      </div>


  </div>
</template>

<script>
import Vue from "vue";
import {commonMixins} from '../../mixins/commonMixins';
import {contractMixins} from '../../mixins/contractMixins';

var self;

export default {
   name: "EditTimeLog",
   
    mixins: [commonMixins, contractMixins],
    data: () => ({
      userId: 0,
      timeLogId : 0,
      loading:false,
      name: '',
      name_err_msg: '',
      status: '',
      status_err_msg: '',
      total_break: '',
      total_break_err_msg: '',
      total_maintenance: '',
      total_maintenance_err_msg: '',
      total_time: '',
      total_time_err_msg: '',
      current_date_err_msg: '',
      current_date: '',
      updated_total: '',
      updated_total_err_msg: '',
      optionsDate: {
          format: 'HH:mm:ss',
          useCurrent: false,
      },
      permissions:[],
      cantAccessPage:""  
    }),
    watch:{

        permissions: function(permission){
            var self = this;
            permission.forEach(function (permissions) {
                if(permissions.name == 'user_log_entry_add') {
                    self.cantAccessPage = true;
                }
            });
        },
    },
    beforeMount() {
      self = this;
    },
    mounted: function() {

        var userObj = JSON.parse(localStorage.getItem("user_obj"));
        if (userObj != null) {
          console.log(userObj.first_name);
          self.userId = userObj.id;
        }

        // var d = new Date();

        // self.update_duration = d;
        this.getPermissions();
        var path = window.location.pathname;
        var segments = path.split("/");
        if (segments[3]) {
          self.timeLogId = segments[3];
          self.getLogDetail();
        }

        console.log(self.timeLogId);


    },
    methods: {
      UpdateLog: function() {
        if(self.updated_total) {

          console.log(self.updated_total);
          self.loading = true;
          $.ajax({
              url: process.env.ROOT_API + '/user-workdata/update',
              type: "POST",
              crossDomain: true,
              dataType: "json",
              headers: this.ajxHeaders,
              data:{
                id: self.timeLogId,
                update_time: self.updated_total,
                user_id: self.userId,
              },

              success: function(data) {
                self.loading = false;  
                if (data.status == "success") {

                  self.Back();

                }


              },
              error: function(jqXHR, exception) {
                self.loading = false;
                console.log("data == ", jqXHR);
                  self.generateStatusCodeMessage(jqXHR, true, 'get-log-view')
              }
          });


        } else {
          self.updated_total_err_msg = 'Please Enter Update Time';
        }

      },
      Back: function () {
        var self = this;
        self.$router.push('/user-log-entry');
      },
      getLogDetail: function() {
        self.loading = true;  
        $.ajax({
            url: process.env.ROOT_API + "/user-workdata/get?id=" + self.timeLogId,
            type: "GET",
            crossDomain: true,
            dataType: "json",
            headers: this.ajxHeaders,
            data:{},

            success: function(data) {
              self.loading = false;
              console.log("res == ",data);
              self.name = data.content.name;
              self.total_time = data.content.total_time;
              self.current_date = data.content.current_date;
              self.total_maintenance = data.content.total_maintenance;
              self.total_time = data.content.total_time;
              self.updated_total = data.content.updated_total;
              self.status = data.content.status;
            },
            error: function(jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR, true, 'get-log-view')
            }
        });
      }

    }

}
</script>





// WEBPACK FOOTER //
// src/components/WorkEntry/UserLogEntryEdit.vue